const sidebar: any = [
  {
    sidebar_title: "Admin",
    items: [
      {
        urls_title: "İdarə paneli",
        urls: [
          {
            url_name: "Statistika",
            url_path: "",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Rollar",
    items: [
      {
        urls_title: "Rollar",
        urls: [
          {
            url_name: "Adminlər",
            url_path: "admins",
          },
          {
            url_name: "İcazələr",
            url_path: "permissions",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Parametrlər",
    items: [
      {
        urls_title: "Parametrlər",
        urls: [
          {
            url_name: "Parametrlər",
            url_path: "settings",
          },
          {
            url_name: "Dillər",
            url_path: "languages",
          },
          {
            url_name: "Partnyorlar",
            url_path: "partners",
          },
          {
            url_name: "Rəsmi servis mərkəzi",
            url_path: "official_service",
          },
          {
            url_name: "Səhifələr",
            url_path: "pages",
          },
          {
            url_name: "Haqqımızda",
            url_path: "about",
          },
          {
            url_name: "Lüğət",
            url_path: "dictionary",
          },
          // {
          //   url_name: "Zəmanət şərtləri",
          //   url_path: "warranty-terms",
          // },
        ],
      },
    ],
  },

  {
    sidebar_title: "Kateqoriyalar",
    items: [
      {
        urls_title: "Məhsul kateqoriyaları",
        urls: [
          {
            url_name: "Kateqoriyalar",
            url_path: "categories",
          },
          {
            url_name: "Brendlər",
            url_path: "brands",
          },
          {
            url_name: "Ölkələr",
            url_path: "countries",
          },
          {
            url_name: "Xüsusiyyətlər",
            url_path: "category-specs",
          },
          {
            url_name: "Qrup Adları",
            url_path: "category-specs-group-names",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Məhsullar",
    items: [
      {
        urls_title: "Məhsullar",
        urls: [
          {
            url_name: "Məhsullar",
            url_path: "products",
          },
          {
            url_name: "Kampaniyalar",
            url_path: "campaigns",
          },
          {
            url_name: "Həftənin seçilmişləri",
            url_path: "weekly_picks_products",
          },
          {
            url_name: "Rənglər",
            url_path: "colors",
          },
          {
            url_name: "Anbarlar",
            url_path: "warehouse",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Xidmətlər",
    items: [
      {
        urls_title: "Xidmətlər",
        urls: [
          {
            url_name: "Xidmətlər",
            url_path: "services",
          },
          {
            url_name: "Müraciətlər",
            url_path: "repair_order",
          },
          {
            url_name: "Xidmət qrupları",
            url_path: "services_groups",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Sifarişlər",
    items: [
      {
        urls_title: "Sifarişlər",
        urls: [
          {
            url_name: "Sifariş statusları",
            url_path: "order_status",
          },
          {
            url_name: "Məhsul sifarişləri",
            url_path: "product_orders",
          },
          {
            url_name: "Bir kliklə al",
            url_path: "quick_orders",
          },
          {
            url_name: "Təmir üçün sifarişlər",
            url_path: "service_orders",
          },
          {
            url_name: "Quraşdırma üçün sifarişlər ",
            url_path: "install_orders",
          },
          {
            url_name: "Aksesuar sifarişləri",
            url_path: "accessory_orders",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Əlaqə",
    items: [
      {
        urls_title: "Əlaqə məlumatları",
        urls: [
          {
            url_name: "Əlaqə",
            url_path: "contact",
          },
          {
            url_name: "Filiallar",
            url_path: "branchs",
          },
          {
            url_name: "Abunə olanlar",
            url_path: "subscribers",
          },
        ],
      },
    ],
  },
  {
    sidebar_title: "Kontentlər",
    items: [
      {
        urls_title: "İstifadəçi üçün",
        urls: [
          {
            url_name: "Xəbərlər",
            url_path: "news",
          },
          {
            url_name: "Vakansiya",
            url_path: "vacancy",
          },
          {
            url_name: "Bloqlar",
            url_path: "blogs",
          },
          {
            url_name: "Video təlimlər",
            url_path: "video",
          },
          {
            url_name: "ChatBot Şablonları",
            url_path: "chatbot-templates",
          },
          {
            url_name: "Canlı Dəstək",
            url_path: "live-support",
          },
          {
            url_name: "Ana Hero",
            url_path: "home-heroes",
          },
          {
            url_name: "Outlet Hero",
            url_path: "outlet-heroes",
          },
        ],
      },
    ],
  },
];

export default sidebar;
